<app-print-layout (cancelar)="cancelar()">
    <div class="card-body">
        <div>
            <div class="row mb-1">
                <div class="col-md-12" style="font-weight: bold; font-size: 18pt; text-align: center;">
                    <span>PROGRAMA DE TRABALHO - {{Ug}}</span>
                    <br>
                    <span>PT.P-{{indice}}</span>
                </div>
            </div>
            <div class="row mb-2">
                <div class="col-md-12">
                    <div>Nº da Ordem de Serviço:</div>
                    <div>Unidade(s) Gestora(s) auditada(s):</div>
                    <div>Equipe responsável:</div>
                    <div>Data de preenchimento:</div>
                </div>
                <div class="col-md-12" style="padding-top: 15px;">
                    <table class="table" style="border: 1px solid #ccc; border-collapse: collapse; width: auto;">
                        <thead>
                            <tr>
                                <th colspan="2" style="width: 460px; text-align: center; border: 1px solid #ccc;">
                                    Questão de Auditoria
                                </th>
                                <th style="width: 300px; text-align: center; border: 1px solid #ccc;">
                                    Critério aplicável
                                </th>
                                <th style="width: 130px; text-align: center; border: 1px solid #ccc;">
                                    Avaliação
                                </th>
                                <th style="width: 130px; text-align: center; border: 1px solid #ccc;">
                                    Evidências
                                </th>
                                <th style="width: 130px; text-align: center; border: 1px solid #ccc;">
                                    Observações
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let item of model">
                                <td style="width: 60px; border: 1px solid #ccc; vertical-align: middle;">{{ item.codigo
                                    }}</td>
                                <td style="width: 400px; border: 1px solid #ccc; vertical-align: middle;">{{
                                    item.procedimento }}</td>
                                <td style="width: 300px; border: 1px solid #ccc;">{{ item.criterioAplicavel }}</td>
                                <td style="width: 130px; border: 1px solid #ccc;"></td>
                                <td style="width: 130px; border: 1px solid #ccc;"></td>
                                <td style="width: 130px; border: 1px solid #ccc;"></td>
                            </tr>
                        </tbody>
                    </table>

                </div>
            </div>
        </div>
    </div>
</app-print-layout>